import { ReactComponent as LuggageIcon } from "assets/images/iconsV2/luggage-02.svg";
import { ReactComponent as PlaneDollarIcon } from "assets/images/iconsV2/plane-dollar.svg";
import { ReactComponent as PlaneRightArrowIcon } from "assets/images/iconsV2/plane-right-arrow.svg";
import { ReactComponent as PlaneIcon } from "assets/images/iconsV2/plane.svg";
import { ReactComponent as CargoShipIcon } from "assets/images/iconsV2/cargo-ship.svg";
import { ReactComponent as TruckIcon } from "assets/images/iconsV2/truck.svg";
import { ReactComponent as TrainIcon } from "assets/images/iconsV2/train.svg";
import { ReactComponent as PackageIcon } from "assets/images/iconsV2/package.svg";

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const FREIGHT_MODE_ICON_MAP: Record<string, SvgComponent> = {
  OBC: LuggageIcon,
  air_charter: PlaneDollarIcon,
  NFO: PlaneRightArrowIcon,
  regular_air: PlaneIcon,
  ocean_freight: CargoShipIcon,
  road_freight: TruckIcon,
  rail_freight: TrainIcon,
};

const TYPE_FALLBACK_MAP: Record<string, SvgComponent> = {
  air: PlaneIcon,
  ocean: CargoShipIcon,
  road: TruckIcon,
  rail: TrainIcon,
};

export function getFreightModeIcon(value: string, type?: string): SvgComponent {
  if (FREIGHT_MODE_ICON_MAP[value]) return FREIGHT_MODE_ICON_MAP[value];
  if (type && TYPE_FALLBACK_MAP[type]) return TYPE_FALLBACK_MAP[type];
  return PackageIcon;
}
